import addTargetEventListener from '../events/addTargetEventListener';
import { selectors } from './elements/constants';
import getFormWizard from './elements/getFormWizard';
import getStep from './elements/getStep';
import { events } from './models/events';

function updateConsultantVis({target}){
    const wizard = getFormWizard(target);
    var education_consultant = wizard.querySelector(selectors.education_consultant);
    const active_panel = getStep(target);
    const steps = Array.from(wizard.querySelectorAll(selectors.step));

    if(education_consultant && steps[0] != active_panel){
        education_consultant.style.display = 'block';
    } else if (education_consultant) {
        education_consultant.style.display = 'none';
    }
}

addTargetEventListener(events.showStep, selectors.wrapper, updateConsultantVis);
